import { createElement } from "react";
import { LoadedCorpus_Msg } from "../../Update.js";
import { SearchInterface } from "../../Model/Model.js";
import { singleton as singleton_1, cons, ofArray } from "../../../fable_modules/fable-library.3.7.9/List.js";
import { StringUtils_replace } from "../../../Shared/Shared.js";
import { split, isMatch } from "../../../fable_modules/fable-library.3.7.9/RegExp.js";
import { printf, toText, join } from "../../../fable_modules/fable-library.3.7.9/String.js";
import { mapIndexed, map } from "../../../fable_modules/fable-library.3.7.9/Array.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library.3.7.9/Seq.js";
import { view as view_1 } from "./Extended.js";
import { PropHelpers_createOnKey } from "../../../fable_modules/Feliz.1.64.0/Properties.fs.js";
import { key_enter } from "../../../fable_modules/Feliz.1.64.0/Key.fs.js";
import { equals, int32ToString, createObj } from "../../../fable_modules/fable-library.3.7.9/Util.js";
import { Helpers_combineClasses } from "../../../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";
import { Interop_reactApi } from "../../../fable_modules/Feliz.1.64.0/Interop.fs.js";
import { map as map_1, defaultArg } from "../../../fable_modules/fable-library.3.7.9/Option.js";
import { tryParse, fromInt, toString } from "../../../fable_modules/fable-library.3.7.9/Long.js";
import { FSharpRef } from "../../../fable_modules/fable-library.3.7.9/Types.js";
import { tryParse as tryParse_1 } from "../../../fable_modules/fable-library.3.7.9/Int32.js";

export function view(corpus, search, dispatch) {
    let props_22, properties_11, elems_7, children_5, children_3, props_18, props_25, properties_17, elems_8, props_29, properties_20, elems_9, props_27, children_7, elems_20;
    const link = (title, heading, interface$) => createElement("a", {
        title: title,
        onClick: (_arg1) => {
            dispatch(new LoadedCorpus_Msg(3, interface$));
        },
        children: heading,
    });
    const simpleLink = link("Simple search box", "Simple", new SearchInterface(0));
    const extendedLink = link("Search for grammatical categories etc.", "Extended", new SearchInterface(1, void 0));
    const cqpLink = link("CQP expressions", "CQP query", new SearchInterface(2));
    const separator = createElement("span", {
        style: {
            whiteSpace: "pre",
        },
        children: " | ",
    });
    let links;
    const matchValue = search.Interface;
    switch (matchValue.tag) {
        case 1: {
            links = ofArray([simpleLink, separator, createElement("b", {
                children: ["Extended"],
            }), separator, cqpLink]);
            break;
        }
        case 2: {
            links = ofArray([simpleLink, separator, extendedLink, separator, createElement("b", {
                children: ["CQP query"],
            })]);
            break;
        }
        default: {
            links = ofArray([createElement("b", {
                children: ["Simple"],
            }), separator, extendedLink, separator, cqpLink]);
        }
    }
    const queryText = (query) => {
        const matchValue_1 = search.Interface;
        switch (matchValue_1.tag) {
            case 1: {
                return "";
            }
            case 2: {
                const text_1 = StringUtils_replace("%contains%", " contains ", StringUtils_replace("%not%contains%", " not contains ", StringUtils_replace("__QUOTE__", "\"", query.QueryString)));
                if (query.HasFinalSpace) {
                    return text_1 + " ";
                }
                else {
                    return text_1;
                }
            }
            default: {
                const text = StringUtils_replace("\\.[\\*\\+]", "*", StringUtils_replace("__QUOTE__", "\"", StringUtils_replace("^!", "", StringUtils_replace("\\s*\\[\\]\\s*", " .* ", StringUtils_replace("\"([^\\s=]+)\"", "$1", StringUtils_replace("\\[\\(?\\w+=\"(.*?)\"(?:\\s+%c)?\\)?\\]", "$1", StringUtils_replace("\\\\(.)", "$1", StringUtils_replace("\u003c/?(?:s|who)?\u003e", "", query.QueryString))))))));
                if (text === " * ") {
                    return "";
                }
                else if (query.HasFinalSpace) {
                    return text + " ";
                }
                else {
                    return text;
                }
            }
        }
    };
    const textInputToQuery = (inputValue) => {
        const matchValue_2 = search.Interface;
        switch (matchValue_2.tag) {
            case 1: {
                throw (new Error("Unused!"));
            }
            case 2: {
                return [StringUtils_replace(" contains ", "%contains%", StringUtils_replace(" not contains ", "%not%contains%", StringUtils_replace("^\\\"$", "[word=\"__QUOTE__\"]", StringUtils_replace("word=\"\\\"\"", "word=\"__QUOTE__\"", inputValue.trim())))), isMatch(/\s+$/g, inputValue)];
            }
            default: {
                return [join(" ", map((arg_2) => {
                    const token = StringUtils_replace("\\*", ".*", StringUtils_replace("[\\.\\+\\?\\^\\$\\{\\}\\(\\)\\|\\[\\]\\\\]", "\\$\u0026", StringUtils_replace("\"", "__QUOTE__", arg_2)));
                    if (token === "") {
                        return "[]";
                    }
                    else {
                        return toText(printf("[word=\"%s\" %%c]"))(token);
                    }
                }, split(inputValue.trim(), "\\s+"))), isMatch(/\s+$/g, inputValue)];
            }
        }
    };
    let queryRows;
    let shouldShowDeleteRowButton;
    const matchValue_4 = search.Interface;
    switch (matchValue_4.tag) {
        case 2: {
            shouldShowDeleteRowButton = (search.Params.Queries.length > 1);
            break;
        }
        case 1: {
            shouldShowDeleteRowButton = false;
            break;
        }
        default: {
            shouldShowDeleteRowButton = (search.Params.Queries.length > 1);
        }
    }
    queryRows = mapIndexed((queryIndex_3, query_8) => {
        const props_16 = toList(delay(() => append(shouldShowDeleteRowButton ? append(singleton(["className", "has-addons"]), delay(() => singleton(["className", "has-addons-right"]))) : empty(), delay(() => {
            let elems_4;
            return singleton((elems_4 = toList(delay(() => {
                let props_9, elems, queryIndex_2, query_7, matchValue_3, props_7, props_5;
                return append(singleton((props_9 = ofArray([["className", "is-expanded"], (elems = [(queryIndex_2 = (queryIndex_3 | 0), (query_7 = query_8, (matchValue_3 = search.Interface, (matchValue_3.tag === 1) ? view_1(corpus, search, query_7, queryIndex_2, matchValue_3.fields[0], dispatch) : ((matchValue_3.tag === 2) ? ((props_7 = ofArray([["value", queryText(query_7)], ["onKeyUp", (ev_2) => {
                    PropHelpers_createOnKey(key_enter, (_arg3) => {
                        dispatch(new LoadedCorpus_Msg(21));
                    }, ev_2);
                }], ["onChange", (ev_3) => {
                    const patternInput_1 = textInputToQuery(ev_3.target.value);
                    dispatch(new LoadedCorpus_Msg(4, patternInput_1[0], queryIndex_2, patternInput_1[1]));
                }]]), createElement("input", createObj(cons(["type", "search"], Helpers_combineClasses("input", props_7)))))) : ((props_5 = ofArray([["value", queryText(query_7)], ["onKeyUp", (ev) => {
                    PropHelpers_createOnKey(key_enter, (_arg2) => {
                        dispatch(new LoadedCorpus_Msg(21));
                    }, ev);
                }], ["onChange", (ev_1) => {
                    const patternInput = textInputToQuery(ev_1.target.value);
                    dispatch(new LoadedCorpus_Msg(4, patternInput[0], queryIndex_2, patternInput[1]));
                }]]), createElement("input", createObj(cons(["type", "search"], Helpers_combineClasses("input", props_5))))))))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]), createElement("div", createObj(Helpers_combineClasses("control", props_9))))), delay(() => {
                    let children_1, props_13, elems_2, elms;
                    return shouldShowDeleteRowButton ? singleton((children_1 = singleton_1((props_13 = ofArray([["className", "is-danger"], ["title", "Delete row"], ["onClick", (_arg4) => {
                        dispatch(new LoadedCorpus_Msg(6, queryIndex_3));
                    }], (elems_2 = [(elms = singleton_1(createElement("i", {
                        className: join(" ", ["fa fa-times"]),
                    })), createElement("span", {
                        className: "icon",
                        children: Interop_reactApi.Children.toArray(Array.from(elms)),
                    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]), createElement("button", createObj(Helpers_combineClasses("button", props_13))))), createElement("div", {
                        className: "control",
                        children: Interop_reactApi.Children.toArray(Array.from(children_1)),
                    }))) : empty();
                }));
            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))]));
        }))));
        return createElement("div", createObj(Helpers_combineClasses("field", props_16)));
    }, search.Params.Queries);
    const randomResultsControls = ofArray([(props_22 = ofArray([(properties_11 = singleton_1(["marginRight", 0.5 + "rem"]), ["style", createObj(properties_11)]), (elems_7 = [(children_5 = singleton_1((children_3 = singleton_1((props_18 = ofArray([["style", {
        width: 55,
    }], ["value", defaultArg(map_1(toString, search.Params.NumRandomHits), "")], ["onChange", (ev_4) => {
        let matchValue_5, outArg;
        const s_2 = ev_4.target.value;
        dispatch(new LoadedCorpus_Msg(19, (matchValue_5 = ((outArg = fromInt(0), [tryParse(s_2, 511, false, 64, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg])), matchValue_5[0] ? matchValue_5[1] : (void 0))));
    }], ["onKeyUp", (ev_5) => {
        PropHelpers_createOnKey(key_enter, (_arg5) => {
            dispatch(new LoadedCorpus_Msg(21));
        }, ev_5);
    }]]), createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props_18)))))), createElement("div", {
        className: "control",
        children: Interop_reactApi.Children.toArray(Array.from(children_3)),
    }))), createElement("div", {
        className: "field",
        children: Interop_reactApi.Children.toArray(Array.from(children_5)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])]), createElement("div", createObj(Helpers_combineClasses("level-item", props_22)))), (props_25 = ofArray([(properties_17 = singleton_1(["marginRight", 0.35 + "rem"]), ["style", createObj(properties_17)]), (elems_8 = [createElement("span", {
        className: "",
        children: "random results (with seed:",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])]), createElement("div", createObj(Helpers_combineClasses("level-item", props_25)))), (props_29 = ofArray([(properties_20 = singleton_1(["marginRight", 0.5 + "rem"]), ["style", createObj(properties_20)]), (elems_9 = [(props_27 = ofArray([["style", {
        width: 50,
    }], ["value", defaultArg(map_1(int32ToString, search.Params.RandomHitsSeed), "")], ["onChange", (ev_6) => {
        let matchValue_6, outArg_1;
        dispatch(new LoadedCorpus_Msg(20, (matchValue_6 = ((outArg_1 = 0, [tryParse_1(ev_6.target.value, 511, false, 32, new FSharpRef(() => outArg_1, (v_2) => {
            outArg_1 = (v_2 | 0);
        })), outArg_1])), matchValue_6[0] ? matchValue_6[1] : (void 0))));
    }], ["onKeyUp", (ev_7) => {
        PropHelpers_createOnKey(key_enter, (_arg6) => {
            dispatch(new LoadedCorpus_Msg(21));
        }, ev_7);
    }]]), createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props_27)))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])]), createElement("div", createObj(Helpers_combineClasses("level-item", props_29)))), (children_7 = singleton_1(createElement("span", {
        className: "",
        children: ")",
    })), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_7)),
    }))]);
    const searchButton = createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Search"], ["onClick", (_arg7) => {
        dispatch(new LoadedCorpus_Msg(21));
    }]]))));
    const orButton = createElement("button", createObj(Helpers_combineClasses("button", ofArray([["onClick", (_arg8) => {
        dispatch(new LoadedCorpus_Msg(5));
    }], ["children", "Or..."]]))));
    return createElement("div", createObj(ofArray([["style", {
        width: 500,
    }], (elems_20 = toList(delay(() => {
        let props_40, elems_14, elms_2;
        return append(singleton((props_40 = ofArray([["style", {
            paddingTop: 20,
        }], (elems_14 = [(elms_2 = singleton_1(createElement("div", {
            className: "level-item",
            children: Interop_reactApi.Children.toArray(Array.from(links)),
        })), createElement("div", {
            className: "level-left",
            children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
        })), createElement("div", {
            className: "level-right",
            children: Interop_reactApi.Children.toArray([searchButton]),
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_14))])]), createElement("nav", createObj(Helpers_combineClasses("level", props_40))))), delay(() => append(queryRows, delay(() => {
            let elm_6, elms_4;
            return singleton((elm_6 = [(elms_4 = toList(delay(() => {
                let props_44, properties_34, elems_17, children_14;
                return append(singleton((props_44 = ofArray([(properties_34 = singleton_1(["marginRight", 4.5 + "rem"]), ["style", createObj(properties_34)]), (elems_17 = [(children_14 = singleton_1(createElement("div", {
                    className: "control",
                    children: Interop_reactApi.Children.toArray([orButton]),
                })), createElement("div", {
                    className: "field",
                    children: Interop_reactApi.Children.toArray(Array.from(children_14)),
                }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_17))])]), createElement("div", createObj(Helpers_combineClasses("level-item", props_44))))), delay(() => ((!equals(search.Interface, new SearchInterface(0))) ? randomResultsControls : empty())));
            })), createElement("div", {
                className: "level-left",
                children: Interop_reactApi.Children.toArray(Array.from(elms_4)),
            }))], createElement("nav", {
                className: "level",
                children: Interop_reactApi.Children.toArray(Array.from(elm_6)),
            })));
        }))));
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_20))])])));
}

